<template>
  <asc-page-loading-indicator
    :loading="isAnserToolLoading && !apiPageFailure.length"
  >
    <v-container fluid class="asc-anser-tool-container pa-4">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <template v-if="isAnserToolPageActive">
            <asc-anser-signature-template :plotly-data="plotlyTokens" />
          </template>
        </v-col>
      </v-row>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator.vue'
import AscAnserSignatureTemplate from '../../../templates/AscAnserSignatureTemplate.vue'

import AppFeatureFlags from '@/utilities/appFeatureFlags'

import { mapState, mapGetters, mapActions } from 'vuex'
import {
  ANSER_TOOL_CONSTS as ATC,
  LOOKUP_CONSTS as LC,
  PLOTLY_CONSTS as PLYC,
} from '@/stores/consts'

export default {
  name: 'AscSignatureSelectionContainer',

  components: {
    AscPageLoadingIndicator,
    AscAnserSignatureTemplate,
  },

  data() {
    return {
      isSignaturesLoading: false,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(LC.NAMESPACE, ['aircraftsLoading', 'masterModelsLoading']),
    ...mapGetters(ATC.NAMESPACE, ['mappedGFUserAirlinesWithMasterModels']),
    ...mapState(PLYC.NAMESPACE, ['plotlyTokens']),

    isAnserToolPageActive() {
      return AppFeatureFlags.getAnserToolPage()
    },

    isAnserToolLoading() {
      return (
        this.aircraftsLoading ||
        this.masterModelsLoading ||
        this.isSignaturesLoading
      )
    },

    getMappedUserAirlines() {
      return this.mappedGFUserAirlinesWithMasterModels
    },
  },

  async mounted() {
    this.isSignaturesLoading = true
    await this[PLYC.GET_PLOTLY_TOKEN]({
      data: {
        airline: this.$route.query.airline,
        platform: this.$route.query.platform,
        last_updated: this.$route.query.lastModifiedDate,
      },
      type: 'ANSER',
    })
    this.isSignaturesLoading = false
  },

  methods: {
    ...mapActions(PLYC.NAMESPACE, [PLYC.GET_PLOTLY_TOKEN]),
  },
}
</script>
